import { instanceConexao } from "services/axiosServices";
import { AxiosRequestConfig } from "axios";
import { useQuery } from "@tanstack/react-query";

/**
 * Função para buscar os empreendimentos de revenda.
 *
 * @param {string} authToken - Token de autenticação do usuário.
 * @returns {UseQueryResult<any, unknown>} - Resultado da query.
 *
 * A resposta é um array de objetos.
 */
export function fetchRevendaEmpreendimentosListar({
  enabled,
  authToken,
  status,
  registros,
  pagina,
}: {
  enabled?: boolean;
  authToken: string;
  status?: boolean;
  registros?: number;
  pagina?: number;
}): any {
  const fetch = async (): Promise<any> => {
    const url = "/api/RevendaEmpreendimento/ListarPorFiltro";
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    };
    const response = await instanceConexao.post(
      url,
      {
        pagina: pagina ?? 1,
        registros: registros ?? 5000,
        status: status ?? true,
      },
      config
    );
    return response?.data?.data?.data;
  };

  const query = useQuery({
    queryFn: async () => fetch(),
    queryKey: ["fetch-revenda-empreendimento-listar"],
    enabled: enabled ?? false,
    refetchOnWindowFocus: false,
  });

  return query;
}

/**
 * Função para listar os empreendimentos de revenda.
 *
 * @param {string} authToken - Token de autenticação do usuário.
 * @returns {Promise<any>} - Retorna a resposta da API contendo os dados dos empreendimentos de revenda.
 *
 * A resposta é um array de objetos.
 */
export const postRevendaEmpreendimentosListar = async (
  authToken: string
): Promise<any> => {
  const url = "/api/RevendaEmpreendimento/ListarPorFiltro";
  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  };
  const response = await instanceConexao.post(url, {}, config);
  return response?.data?.data;
};
